import React from "react";
import { BootstrapAccordion } from "wm_global";
import {
  MdPictureAsPdf,
  MdOutlineSecurity,
  MdInsertPhoto,
  MdOutlineContentCopy,
} from "react-icons/md";
import { CgScreenShot, CgDropInvert } from "react-icons/cg";
import { AiFillFileAdd, AiOutlineExclamationCircle } from "react-icons/ai";
import { TfiFaceSad } from "react-icons/tfi";
import { FaPersonWalking } from "react-icons/fa6";
import { FAQAccordionItem } from "./faq_item.jsx";

export const FAQ = ({ scanCopyFax }) => {
  const accordionId = "faq-accordion";

  const canScanCopyFaxText = () => {
    let text = "This location does";
    scanCopyFax ? null : (text += " not");
    text += " have scan, copy, and fax available.";

    return text;
  };

  return (
    <section data-testid="faq">
      <div className="mb-4">
        <h2 className="text-center text-sm-start">FAQ</h2>
      </div>

      <BootstrapAccordion accordionId={accordionId}>
        <FAQAccordionItem
          accordionId={accordionId}
          question={"What types of files can I print?"}
          answer={
            <span>
              <b>We recommend using PDF for best results</b>, but we support
              these filetypes: .pdf .docx .doc .jpeg .jpg .png .tiff .gif .rtf
              .odt .txt .pptx .ppt
            </span>
          }
          itemId={"item-1"}
          icon={<MdPictureAsPdf />}
        />
        <FAQAccordionItem
          accordionId={accordionId}
          question={"What size and quality paper do you use?"}
          answer={
            'We use Hammermill Premium Laser Print, 24 lb, 98 Brightness paper. We print on standard 8½"x11" size paper.'
          }
          itemId={"item-2"}
          icon={<CgScreenShot />}
        />
        <FAQAccordionItem
          accordionId={accordionId}
          question={"How can I print multiple files?"}
          answer={
            "Our web application allows you to upload multiple files. If you are creating an order via email just attach all the desired files to the email. We recommend doing this instead of creating multiple orders."
          }
          itemId={"item-3"}
          icon={<AiFillFileAdd />}
        />
        <FAQAccordionItem
          accordionId={accordionId}
          question={"Are my files secure and private?"}
          answer={
            "Yes! We encrypt all files we receive and securely delete them from our servers once they've been printed according to industry best practices. We do not scan the contents of your documents for advertising or any reason."
          }
          itemId={"item-4"}
          icon={<MdOutlineSecurity />}
        />
        <FAQAccordionItem
          accordionId={accordionId}
          question={"What if the printer is out of paper, ink, or toner?"}
          answer={
            "We remotely monitor the supply levels in our printers and inform on-site staff when refills are needed. However, if there happens to be an outage preventing you from printing you can ask a staff member or call our support team at +773-797-2118 for quick service."
          }
          itemId={"item-5"}
          icon={<TfiFaceSad />}
        />
        <FAQAccordionItem
          accordionId={accordionId}
          question={"Can I print photos?"}
          answer={
            "We can handle many image file formats (.jpeg .jpg .png .tiff .gif .png) but be advised our printers are not photo-quality printers and we use regular copy paper so results will vary."
          }
          itemId={"item-6"}
          icon={<MdInsertPhoto />}
        />
        <FAQAccordionItem
          accordionId={accordionId}
          question={"Can I print remotely and pick up my documents?"}
          answer={
            "We do not offer this option. Documents can only be printed by entering the order's secure release code on the printer’s touchscreen."
          }
          itemId={"item-7"}
          icon={<FaPersonWalking />}
        />
        <FAQAccordionItem
          accordionId={accordionId}
          question={"Can I scan, copy, or fax at this location?"}
          answer={canScanCopyFaxText()}
          itemId={"item-8"}
          icon={<MdOutlineContentCopy />}
        />
        <FAQAccordionItem
          accordionId={accordionId}
          question={"Can I bring my own paper?"}
          answer={
            "No. This printer can only handle its own paper supply and you will not be able to swap out paper when you arrive."
          }
          itemId={"item-10"}
          icon={<AiOutlineExclamationCircle />}
        />
        <FAQAccordionItem
          accordionId={accordionId}
          question={"Does your printer use ink or toner?"}
          answer={
            "We only use laser-jet printers, which use toner. We do not support ink-jet related projects."
          }
          itemId={"item-11"}
          icon={<CgDropInvert />}
        />
      </BootstrapAccordion>

      <div className="mt-2">
        <p>
          <a href="https://printwithme.com/help-center/#faq" target="_blank">
            PrintWithMe Help Center
          </a>
        </p>
      </div>
    </section>
  );
};
